/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ResolveEmailTemplateRequest
 */
export interface ResolveEmailTemplateRequest {
    /**
     * 
     * @type {string}
     * @memberof ResolveEmailTemplateRequest
     */
    clientId: string;
    /**
     * 
     * @type {Date}
     * @memberof ResolveEmailTemplateRequest
     */
    appointment?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof ResolveEmailTemplateRequest
     */
    previousAppointment?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof ResolveEmailTemplateRequest
     */
    newAppointment?: Date | null;
}

/**
 * Check if a given object implements the ResolveEmailTemplateRequest interface.
 */
export function instanceOfResolveEmailTemplateRequest(value: object): value is ResolveEmailTemplateRequest {
    if (!('clientId' in value) || value['clientId'] === undefined) return false;
    return true;
}

export function ResolveEmailTemplateRequestFromJSON(json: any): ResolveEmailTemplateRequest {
    return ResolveEmailTemplateRequestFromJSONTyped(json, false);
}

export function ResolveEmailTemplateRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResolveEmailTemplateRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'clientId': json['clientId'],
        'appointment': json['appointment'] == null ? undefined : (new Date(json['appointment'])),
        'previousAppointment': json['previousAppointment'] == null ? undefined : (new Date(json['previousAppointment'])),
        'newAppointment': json['newAppointment'] == null ? undefined : (new Date(json['newAppointment'])),
    };
}

export function ResolveEmailTemplateRequestToJSON(json: any): ResolveEmailTemplateRequest {
    return ResolveEmailTemplateRequestToJSONTyped(json, false);
}

export function ResolveEmailTemplateRequestToJSONTyped(value?: ResolveEmailTemplateRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'clientId': value['clientId'],
        'appointment': value['appointment'] == null ? value['appointment'] : value['appointment'].toISOString(),
        'previousAppointment': value['previousAppointment'] == null ? value['previousAppointment'] : value['previousAppointment'].toISOString(),
        'newAppointment': value['newAppointment'] == null ? value['newAppointment'] : value['newAppointment'].toISOString(),
    };
}

